import { Component, OnInit, Input, TemplateRef, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { InteractorService } from 'src/app/core/services/interactor.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit, AfterViewInit {
  modalRef: BsModalRef;
  brandingDetails = JSON.parse(localStorage.getItem('branding'));
  semiBoldFont = this.brandingDetails?.branding?.Font?.SemiBoldFont;
  regularFont = this.brandingDetails?.branding?.Font?.RegularFont;
  @Input() Message: string;
  @Output() popupHideCallback = new EventEmitter<boolean>();
  @ViewChild('template') elementView: TemplateRef<any>;
  constructor(private modalService: BsModalService, private interactorService: InteractorService,
    private translatorService: TranslateService) {
    this.translatorService.setDefaultLang('en');
    this.translatorService.use(localStorage.getItem('lang') || 'en');
  }
  ngOnInit(): void {
    this.interactorService.brandingDetailsCast.subscribe(data => {
      if (data) {
        this.brandingDetails = data;
        this.semiBoldFont = this.brandingDetails?.branding?.Font?.SemiBoldFont;
        this.regularFont = this.brandingDetails?.branding?.Font?.RegularFont;
        document.documentElement.style.setProperty('--semiBoldFont', this.semiBoldFont);
        document.documentElement.style.setProperty('--regularFont', this.regularFont);
      }
    });
    document.documentElement.style.setProperty('--semiBoldFont', this.semiBoldFont);
    document.documentElement.style.setProperty('--regularFont', this.regularFont);
  }
  openModal() {
    this.modalRef = this.modalService.show(this.elementView, {
      class: 'modal-dialog-centered',
    });
  }
  ngAfterViewInit() {
    this.openModal();
  }

  okey() {
    this.modalRef.hide();
    this.interactorService.setErrorFlag(false);
    this.popupHideCallback.emit(false);
  }
}
